var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.33333V0H5.33333V5.33333H0ZM1.33333 4H4V1.33333H1.33333V4ZM0 12V6.66667H5.33333V12H0ZM1.33333 10.6667H4V8H1.33333V10.6667ZM6.66667 5.33333V0H12V5.33333H6.66667ZM8 4H10.6667V1.33333H8V4ZM10.6667 12V10.6667H12V12H10.6667ZM6.66667 8V6.66667H8V8H6.66667ZM8 9.33333V8H9.33333V9.33333H8ZM6.66667 10.6667V9.33333H8V10.6667H6.66667ZM8 12V10.6667H9.33333V12H8ZM9.33333 10.6667V9.33333H10.6667V10.6667H9.33333ZM9.33333 8V6.66667H10.6667V8H9.33333ZM10.6667 9.33333V8H12V9.33333H10.6667Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.592dbcfbfa2152ea179150b637a3397d.svg";
export { ForwardRef as ReactComponent };